import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { toast } from 'react-toastify';
import '../App.css';

const EnquiryModal = ({ isOpen, onClose, serviceName }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: serviceName || '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.phone) {
      toast.error('Please fill in all required fields');
      return;
    }

    setIsSubmitting(true);
    const loadingToast = toast.loading('Sending your enquiry...');

    try {
      await addDoc(collection(db, 'enquiries'), {
        ...formData,
        timestamp: serverTimestamp(),
        createdAt: new Date().toISOString()
      });

      toast.update(loadingToast, {
        render: 'Thank you! We will contact you soon.',
        type: 'success',
        isLoading: false,
        autoClose: 3000
      });

      setFormData({
        name: '',
        email: '',
        phone: '',
        service: serviceName || '',
        message: ''
      });

      setTimeout(() => {
        onClose();
      }, 1500);

    } catch (error) {
      console.error('Error submitting enquiry:', error);
      
      let errorMessage = 'Failed to send enquiry. Please try again.';
      if (error.code === 'permission-denied') {
        errorMessage = 'Database permissions error. Please contact support.';
      }

      toast.update(loadingToast, {
        render: errorMessage,
        type: 'error',
        isLoading: false,
        autoClose: 5000
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content enquiry-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>&times;</button>
        
        <h2 className="modal-title">Start Your Project</h2>
        <p className="modal-subtitle">Fill out the form below and we'll get back to you shortly</p>
        
        <form onSubmit={handleSubmit} className="enquiry-form">
          <div className="form-group">
            <label htmlFor="name">Full Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter your name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="your.email@example.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number *</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="+1 (123) 456-7890"
            />
          </div>

          <div className="form-group">
            <label htmlFor="service">Service</label>
            <input
              type="text"
              id="service"
              name="service"
              value={formData.service}
              onChange={handleChange}
              readOnly
              style={{ backgroundColor: '#f5f5f5' }}
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Project Details</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="4"
              placeholder="Tell us about your project..."
            />
          </div>

          <button type="submit" className="btn-submit-enquiry" disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <span className="loader-spinner"></span>
                Sending...
              </>
            ) : (
              'Submit Enquiry'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EnquiryModal;
